module.exports = __webpack_public_path__ + "media/images/osm_store-2d00817af3059bdc6de88543a88cd24f.png";